import { render, staticRenderFns } from "./SlaBadgeVermelho.vue?vue&type=template&id=0d2e4328&"
import script from "./SlaBadgeVermelho.vue?vue&type=script&lang=js&"
export * from "./SlaBadgeVermelho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports